import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchOrdersRequests} from "../../api/orders";
import {SaleOrdersType} from "../../components/catalog/types";

export type initialStateType = {
    isOrdersLoading: boolean;
    ordersData: SaleOrdersType | undefined
}

type fetchOrdersParamsType = {
    pageNum: number,
    searchValue?: string,
    activeFilters?: any,
    isReserve?: boolean,
    isDaily?: boolean,
    isOwn?: boolean,
    isActive?: boolean,
    responsible?: string,
    isPreOrder?: boolean,
}

const initialState: initialStateType = {
    ordersData: undefined,
    isOrdersLoading: true,
}

export const fetchOrders =
    createAsyncThunk("slice/fetchOrders",
        async (values: fetchOrdersParamsType) => {
            const result = await fetchOrdersRequests(values)
            return result.data?.data
        })
export const resetOrders =
    createAsyncThunk("slice/ordersReset",
        async () => initialState
    )

const ordersSliceReducer = createSlice({
    name: "orders",
    initialState,
    reducers: {
        resetOrdersData: (state) => {
            Object.assign(state, initialState)
            state.isOrdersLoading = false
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchOrders.fulfilled, (state, action) => {
            state.ordersData = action.payload
            state.isOrdersLoading = false
        }).addCase(resetOrders.fulfilled, (state, action) => {
            Object.assign(state, initialState);
            state.isOrdersLoading = false;
        }).addCase(fetchOrders.pending, (state, action) => {
            state.isOrdersLoading = true;
        })
    }
})

export const {
    resetOrdersData,
} = ordersSliceReducer.actions;

export default ordersSliceReducer.reducer